




























































import Vue from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { ISplideElement, ISplideOptions } from '../../../../common/interfaces/external.interface';
import { IProduct, IProductImage, ITeaserDot } from '@/common/interfaces/products.interface';
import TeaserDot from '../teaserdot/TeaserDot.vue';
import LocalStorageHelper from '@/helpers/LocalStorageHelper';
import Overlay from '@/components/layout/Overlay.vue';
import ImageGallery from '@/components/newsingleproductpage/subcomponents/topsection/ImageGallery.vue';
import config from '../../../../../config';
import ImageWithErrorMessage from '../imagewitherrormessage/ImageWithErrorMessage.vue';
import TIcons from '@/types/TIcons';

interface ITeaserDotStyle {
  style: string;
  text: string;
}

interface IProductPreview {
  activeSlideIndex: number;
  enlargerIcon: string;
  fallbackImage: string;
  loading: boolean;
  showOverlay: boolean;
  spotlightSplide: HTMLElement | null;
  spotlightSplideOptions: ISplideOptions;
  teaserDotCounter: Record<string, number>;
  teaserDotStyles: ITeaserDotStyle[];
}

const TEASER_DOT_SIZE = 48;
const TEASER_DOT_PADDING = 13;

export default Vue.extend({
  name: `ProductPreview`,
  components: {
    ImageGallery,
    ImageWithErrorMessage,
    Overlay,
    Splide,
    SplideSlide,
    TeaserDot,
  },
  data(): IProductPreview {
    return {
      activeSlideIndex: 0,
      enlargerIcon: TIcons.enlarger,
      fallbackImage: config.images.fallbackImage,
      loading: true,
      showOverlay: false,
      spotlightSplide: null,
      spotlightSplideOptions: {
        arrows: false,
        type: `slide`,
      },
      teaserDotCounter: {
        [`bottom-left`]: 0,
        [`bottom-right`]: 0,
        [`top-left`]: 0,
        [`top-right`]: 0,
      },
      teaserDotStyles: [],
    };
  },
  computed: {
    teaserDotArray(): ITeaserDot[] {
      const discountPercentage = LocalStorageHelper.getPersonalInfo()?.isPartner ? this.productInfo.prices.partner.discountPercentage : this.productInfo.prices.customer.discountPercentage;
      const defaultTeaserDot: ITeaserDot = {
        backgroundColor: `#fff`,
        borderColor: `#000`,
        fontSize: 12,
        id: -1,
        lineHeight: 1.25,
        position: `top-right`,
        text: this.productInfo.soldOut ? `Sold out` : `-${discountPercentage}%`,
        textColor: `#000`,
      };

      return (discountPercentage || this.productInfo.soldOut) ? [defaultTeaserDot].concat(this.teaserDots) : this.teaserDots;
    },
  },
  props: {
    images: {
      required: true,
      type: Array as () => IProductImage[],
    },
    productInfo: {
      required: true,
      type: Object as () => IProduct,
    },
    teaserDots: {
      required: true,
      type: Array as () => ITeaserDot[],
    },
  },
  mounted(): void {
    this.getTeaserDotStyles();
    this.loading = false;
  },
  methods: {
    getTeaserDotStyles(): void {
      for(const teaserDot of this.teaserDotArray) {
        const positionParts: string[] = teaserDot.position.split(`-`);
        this.teaserDotStyles.push({
          style: `${positionParts[0]}: ${TEASER_DOT_PADDING + this.teaserDotCounter[teaserDot.position] * (TEASER_DOT_PADDING + TEASER_DOT_SIZE)}px; ${positionParts[1]}: ${TEASER_DOT_PADDING}px;`,
          text: teaserDot.text,
        });
        this.teaserDotCounter[teaserDot.position]++;
      }
    },
    moveSliderToIndex(index: number): void {
      const splide: ISplideElement = this.$refs.spotlight as ISplideElement;
      splide.go(index);
    },
  },
});
